/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landskin_10_TitleInputs */

const en_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autumn Underlay`)
};

const ar_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بساط أوراق الخريف`)
};

const de_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herbstpolster`)
};

const es_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecho otoñal`)
};

const fr_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coussin d’automne`)
};

const it_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuscino autunnale`)
};

const ja_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`落ち葉のクッション`)
};

const ko_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`가을잎 방석`)
};

const pt_br_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almofada de outono`)
};

const ru_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Осенняя подстилка`)
};

const th_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เบาะใบไม้ร่วง`)
};

const tr_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonbahar Minderi`)
};

const zh_cn_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秋叶林垫`)
};

const zh_tw_landskin_10_title = /** @type {(inputs: Landskin_10_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秋葉林墊`)
};

/**
* | output |
* | --- |
* | "Autumn Underlay" |
*
* @param {Landskin_10_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const landskin_10_title = /** @type {((inputs?: Landskin_10_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landskin_10_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landskin_10_title(inputs)
	if (locale === "ar") return ar_landskin_10_title(inputs)
	if (locale === "de") return de_landskin_10_title(inputs)
	if (locale === "es") return es_landskin_10_title(inputs)
	if (locale === "fr") return fr_landskin_10_title(inputs)
	if (locale === "it") return it_landskin_10_title(inputs)
	if (locale === "ja") return ja_landskin_10_title(inputs)
	if (locale === "ko") return ko_landskin_10_title(inputs)
	if (locale === "pt_br") return pt_br_landskin_10_title(inputs)
	if (locale === "ru") return ru_landskin_10_title(inputs)
	if (locale === "th") return th_landskin_10_title(inputs)
	if (locale === "tr") return tr_landskin_10_title(inputs)
	if (locale === "zh_cn") return zh_cn_landskin_10_title(inputs)
	return zh_tw_landskin_10_title(inputs)
});